import { SVGProps } from 'react';

const UserScaleSmallKindSingleEnclosedTrue = (props: SVGProps<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clipPath="url(#clip0_308_19)">
            <path
                d="M3.54436 12.9589C3.94991 12.0034 4.89678 11.3333 6.00016 11.3333H10.0002C11.1035 11.3333 12.0504 12.0034 12.456 12.9589M10.6668 6.33331C10.6668 7.80607 9.47292 8.99998 8.00016 8.99998C6.5274 8.99998 5.3335 7.80607 5.3335 6.33331C5.3335 4.86055 6.5274 3.66665 8.00016 3.66665C9.47292 3.66665 10.6668 4.86055 10.6668 6.33331ZM14.6668 7.99998C14.6668 11.6819 11.6821 14.6666 8.00016 14.6666C4.31826 14.6666 1.3335 11.6819 1.3335 7.99998C1.3335 4.31808 4.31826 1.33331 8.00016 1.33331C11.6821 1.33331 14.6668 4.31808 14.6668 7.99998Z"
                stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
                strokeWidth={1.33333}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_308_19">
                <rect width={16} height={16} fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export default UserScaleSmallKindSingleEnclosedTrue;
